import createSagaMiddleware from "redux-saga";
import { configureStore, type EnhancedStore } from "@reduxjs/toolkit";
import { middleware as apiMiddleware } from "common/redux/core/api.base";
import rootSaga from "./root.saga";
import rootReducer from "./root.reducer";
import initialState from "./root.state";
import { ENV_CONFIG } from "common/config/env.config";

let store: EnhancedStore;

const configureAppStore = (): EnhancedStore => {
  const sagaMiddleware = createSagaMiddleware();
  store = configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleWares) =>
      getDefaultMiddleWares({ serializableCheck: false }).concat(
        sagaMiddleware,
        apiMiddleware
      ),
    devTools: ENV_CONFIG.IS_DEV_ENV
  });
  sagaMiddleware.run(rootSaga);
  return store;
};

export default configureAppStore;

export { store };
export type AppDispatch = typeof store.dispatch;
